// prevent scroll when open popup
const preventScroll = () => {
	const body = document.body;
	const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
	body.style.position = 'fixed';
	body.style.top = `-${scrollY}`;
	body.style.width = '100%';
};

// cancel prevent scroll when open popup
const cancelPreventScroll = () => {
	const body = document.body;
	const scrollY = body.style.top;
	body.style.position = '';
	body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

// set position default when
const setPositionBody = () => {
	window.addEventListener('scroll', () => {
		document.documentElement.style.setProperty(
			'--scroll-y',
			`${window.scrollY}px`
		);
	});
};
setPositionBody();

// scroll to top
const moveToTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};

const scrollTo = (element) => {
	const headerHeight = document.getElementsByClassName(
		'shopify-section__header'
	)[0].offsetHeight;
	const offsetHeightEle = element.getBoundingClientRect().top + window.scrollY;

	// 10 is space from element to header, improve UI
	window.scroll({
		top: offsetHeightEle - headerHeight - 10,
		behavior: 'smooth'
	});
};

const showCommonModal = (elementId) => {
	const element = document.getElementById(elementId);
	element.setAttribute('aria-hidden', 'false');
	preventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.add('hide');
};

const hideModal = () => {
	const modalRegister = document.querySelector('[aria-hidden="false"]');

	modalRegister.setAttribute('aria-hidden', 'true');
	cancelPreventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.remove('hide');
};

const showLoading = () => {
	const loading = document.getElementById('loading-circle');
	loading.style.display = 'block';
	preventScroll();

	const btnToTop = document.getElementById('btn-to-top');
	btnToTop.classList.add('hide');
};

const hideLoading = () => {
	const loading = document.getElementById('loading-circle');
	loading.style.display = 'none';
	cancelPreventScroll();
};

const showError = (text, isNeedHideModal = true) => {
	if (isNeedHideModal) {
		hideLoading();
	}
	setTimeout(() => {
		alert(text);
	}, 300);
};

/* header serchbar control */
/*検索候補非表示コメントアウト
const headerSearchBar = document.querySelector('.pr_search-bar');
const headerSearchBarLink = document.querySelector('.pr_search-bar .nav-bar__link');
const headerSearchBarWrapper = document.querySelector('.pr_header__search-bar-wrapper');
const headerSearchBarInput = document.querySelector('.pr_search-bar .search-bar__input[name="q"]');

headerSearchBar.addEventListener('click', function(event) {
  document.body.classList.add('visible-searchbar');    
  setTimeout(function() {
	document.querySelector('.pr_search-bar .search-bar__input[name="q"]').focus();
  }, 50);  
});

document.addEventListener('click', function(event) {
  if (headerSearchBar && headerSearchBar.classList.contains('is-dropdown-open') && document.body.classList.contains('visible-searchbar') && !event.target.closest('.pr_search-bar')) {    
	headerSearchBar.classList.remove('is-dropdown-open');
	headerSearchBarLink.setAttribute('aria-expanded', 'false');
	headerSearchBarWrapper.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('visible-searchbar');
  }
}); */

// 
function initStep() {
	const range = document.querySelectorAll('input[type="range"]');
	if (range != null) {
		range.forEach((elm) => {
			elm.setAttribute('step', 1000);
		});
	}
}
window.addEventListener('load', () => {
	if (document.querySelector('.price-range') != null) {
		initStep();
		setInterval(initStep, 500);
	}
});

// 

// 
function initDataToCF(column_key, val) {
	console.log('column_key:' + column_key);
	console.log('val:' + val);
	CF.ready(function () {
		var $myForm = document.querySelector('form[data-cf-form]');
		var cfForm = $myForm.cfForm;
		cfForm.setFieldValue(column_key, val)
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const customer_forms = document.querySelectorAll('[id="create_customer"], [data-cf-edit-account="true"], [data-section-type="account"] form');
	if (customer_forms != null) {
		customer_forms.forEach((customer_form) => {
			customer_form.classList.add('h-adr');
			const country_name = document.createElement('span');
			country_name.style.display = 'none';
			country_name.classList.add('p-country-name');
			country_name.textContent = 'Japan';
			customer_form.insertBefore(country_name, customer_form.firstElementChild);
			const events = ['click', 'keydown'];
			let postal_code_flag = true;
			let region_flag = true;
			let address1_flag = true;
			let address2_flag = true;
			let yubinbango_flag = true;

			for (let i in events) {
				customer_form.addEventListener(events[i], () => {
					// init postal code
					const postal_code = customer_form.querySelector('.ci-postal-code');
					if (postal_code != null && postal_code_flag) {
						const input = postal_code.querySelector('input');
						input.classList.add('p-postal-code');
						if (customer_form.getAttribute('data-cf-form')) {
							input.addEventListener('input', () => {
								const inputs = customer_form.querySelectorAll('[data-cf-column-key="address_province"], [data-cf-column-key="address"], [data-cf-column-key="address2"]');
								inputs.forEach((elm) => {
									setTimeout(() => {
										if (elm.value.length > 0) {
											initDataToCF(elm.getAttribute('data-cf-column-key'), elm.value);
										}
									}, 500);
								});
							});
						}
						postal_code_flag = false;
					}
					// init region
					const region = customer_form.querySelector('.ci-region');
					const region_select = region.querySelector('select');
					if (region != null && region_flag) {
						const input = document.createElement('input');
						input.classList.add('p-region');
						input.style.display = 'none';
						region.appendChild(input);
						region_flag = false;
					}
					// change region select
					setTimeout(() => {
						const region_input = customer_form.querySelector('.p-region');
						const options = region_select.querySelectorAll('option');
						options.forEach((op) => {
							if (op.value == region_input.value || op.textContent == region_input.value) {
								region_select.value = op.value;
							}
						});
					}, 500);

					// init locality
					const locality = customer_form.querySelector('.ci-address1');
					if (locality != null && address1_flag) {
						const input = locality.querySelector('input');
						input.classList.add('p-locality');
						address1_flag = false;
					}
					// init street address
					const street_address = customer_form.querySelector('.ci-address2');
					if (street_address != null && address2_flag) {
						const input = street_address.querySelector('input');
						input.classList.add('p-street-address');
						input.classList.add('p-extended-address');
						address2_flag = false;
					}
					// init yubibango.js
					if (postal_code_flag == false && region_flag == false && address1_flag == false && address2_flag == false && yubinbango_flag) {
						new YubinBango.MicroformatDom();
						yubinbango_flag = false;
					}
				});
			}
		});
	}
});
// 

class searchBox {
	inputs = document.querySelectorAll('[name="q"]');

	constructor() {
		for (const input of [...this.inputs]) {
			const duplicate = this.duplicate(input);
			input.after(duplicate);
			input.type = 'hidden';

			const parent = input.closest('form');
			duplicate.addEventListener('change', () => this.setQuary(parent, input, duplicate));
			duplicate.addEventListener('input', () => this.setQuary(parent, input, duplicate));

			for (const e of [...parent.querySelectorAll('[type="radio"]')]) {
				e.addEventListener('change', () => this.setQuary(parent, input, duplicate));
			}
		}
	};

	duplicate({ className, placeholder }) {
		return Object.assign(
			document.createElement('input'),
			{
				autocomplete: 'off',
				autocorrect: 'off',
				className,
				placeholder,
				type: 'text'
			}
		);
	};

	setQuary(parent, input, duplicate) {
		if (parent.querySelector('[type="radio"]:checked').value === 'article,page') {
			input.value = duplicate.value;
			return;
		}
		const array = [];
		for (const str of duplicate.value.split(/ |　/)) {
			array.push(str);
		}
		const unique = [...new Set(array.filter(Boolean))];
		const query = [];
		for (const key of ['title:', 'body:']) {
			query.push(key + unique.join('　'));
		}
		for (const value of unique) {
			query.push('tag:検索_' + value);
		}
		input.value = query.join(' OR ');
	};
};

class toggleGlobalMenu {
	buttons = document.querySelectorAll('.nav-bar .nav-bar__link');

	constructor() {
		for (const button of [...this.buttons]) {
			const parent = button.closest('li');
			const container = parent.querySelector('[data-type="menu"]');
			if (container === null) {
				continue;
			}

			button.addEventListener('click', e => {
				const ancestor = button.closest('ul');
				if (ancestor.classList.contains('nav-dropdown--glued') && parent.classList.contains('is-dropdown-open')) {
					e.preventDefault();

					setTimeout(() => {
						ancestor.classList.remove('nav-dropdown--glued');
						parent.classList.remove('is-dropdown-open');
						button.ariaExpanded = false;
						container.ariaHidden = true;
					}, 100);
				}
			});
		}
	};
};

class toggleAccordionMenu {
	menus = document.querySelectorAll('.mobile-menu__nav-list-toggle');

	constructor() {
		for (const i in [...this.menus]) {
			const menu = this.menus[i];
			const parent = menu.closest('.mega-menu__column');
			const container = parent.querySelector('.mobile-menu__nav-collapsible');
			if (container !== null) {
				parent.style.cssText = `--container-height: ${container.scrollHeight}px; --container-offset: ${i % 3};`;
			}

			menu.addEventListener('click', e => {
				if (menu.ariaExpanded === 'true') {
					menu.ariaExpanded = false;
					return;
				}
				for (const m of [...this.menus]) {
					m.ariaExpanded = false;
				}
				menu.ariaExpanded = true;
			});
		}
	};
};

class toggleHamburgerMenu {
	parent = document.querySelector('header .hamburger');

	constructor() {
		if (this.parent === null) {
			return;
		}

		this.button = this.parent.querySelector('.header__mobile-nav-toggle');
		this.drawer = this.parent.querySelector('.mobile-menu');

		this.button.addEventListener('click', () => {
			this.toggleAttr(this.button.ariaExpanded === 'false');
		});

		this.drawer.querySelector('.close').addEventListener('click', () => {
			this.toggleAttr();
		});

		this.setOffset();
		window.addEventListener('scroll', () => this.setOffset());
	};

	toggleAttr(boolean = false) {
		this.button.ariaExpanded = boolean;
		this.drawer.ariaHidden = !boolean;
	};

	setOffset() {
		const bars = [], header = [];
		for (const e of [...document.querySelectorAll('.shopify-section-group-header-group')]) {
			if (e.classList.contains('shopify-section__header')) {
				header.push(e);
				continue;
			}
			bars.push(e);
		}

		let announce = bars.reduce((sum, { offsetHeight }) => sum + offsetHeight, 0);
		if (window.scrollY > announce) {
			announce = 0;
		}

		const nav = document.querySelector('.nav-bar');
		if (nav !== null && document.body.offsetWidth > 1000) {
			announce -= nav.offsetHeight;
		}

		this.drawer.style.cssText = `--header: ${header[0].offsetHeight + announce}px;`;
	};
};

class wrappingModal {
	modals = [...document.querySelectorAll('.wrapping-modal--container')];

	constructor() {
		for (const modal of this.modals) {
			const button = modal.previousElementSibling;
			button.addEventListener('click', () => {
				modal.classList.toggle('active');
			});

			for (const close of [...modal.querySelectorAll('.close')]) {
				close.addEventListener('click', e => {
					e.preventDefault();
					modal.classList.toggle('active');
				});
			}

			const submit = modal.querySelector('.wrapping-modal--inner button');
			submit.addEventListener('click', async () => {
				submit.disabled = true;

				const { key } = submit.dataset;
				const { value } = modal.querySelector(`[name*="${key}"]:checked`);

				const properties = {};
				const json = JSON.parse(submit.nextElementSibling.innerHTML) || [];
				if (json.length > 0) {
					for (const [k, v] of json) {
						properties[k] = v;
					}
				}

				properties['ラッピング'] = value;

				try {
					const res = await (await fetch('/cart/change.js', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'application/json'
						},
						body: JSON.stringify({ id: key, properties })
					})).json();

					location.reload();
				} catch (err) {
					console.error(err);
					alert('商品の更新に失敗しました。');
					modal.classList.toggle('active');
				}
			});
		}
	};
};

class SortKana {
	items = [];
	orders = [
		{ code: 'ア', min: 12450, max: 12458 },
		{ code: 'カ', min: 12459, max: 12467 },
		{ code: 'サ', min: 12469, max: 12477 },
		{ code: 'タ', min: 12479, max: 12488 },
		{ code: 'ナ', min: 12490, max: 12494 },
		{ code: 'ハ', min: 12495, max: 12507 },
		{ code: 'マ', min: 12510, max: 12514 },
		{ code: 'ヤ', min: 12516, max: 12520 },
		{ code: 'ラ', min: 12521, max: 12525 },
		{ code: 'ワ', min: 12527, max: 12531 },
		{ code: 'その他', min: 99999, max: 99999 }
	];

	constructor(stones) {
		this.stones = [...stones];

		for (const e of this.stones) {
			const code = e.dataset?.code !== undefined ? e.dataset.code : e.textContent;
			if (code.includes('その他')) {
				e.dataset.code = 99999;
				continue;
			}

			e.dataset.code = this.pickKana(e.dataset.code);

			// const match = e.textContent.match(/[（(](.+?)[）)]/);
			// e.dataset.code = (match ? match[1] : e.dataset.code)[0];
			e.dataset.code = e.dataset.code.replace(/[\u3041-\u3096]/g, c =>
				String.fromCodePoint(c.charCodeAt(0) + 0x60)
			);
			e.dataset.code = e.dataset.code.normalize('NFD').replace(/[\u3099\u309A]/g, '');
			e.dataset.code = e.dataset.code.codePointAt(0);
		}

		this.items = [...this.stones].sort((a, b) => Number(a.dataset.code) - Number(b.dataset.code));
	};

	pickKana(str) {
		const katakanaMatch = str.match(/[ァ-ンヴー]/);
		if (katakanaMatch) {
			return katakanaMatch[0];
		}

		const hiraganaMatch = str.match(/[ぁ-んゔー]/);
		if (hiraganaMatch) {
			return hiraganaMatch[0];
		}

		return str[0];
	};
};

document.addEventListener('DOMContentLoaded', () => {
	window.searchBox = new searchBox;
	window.toggleGlobalMenu = new toggleGlobalMenu;
	window.toggleAccordionMenu = new toggleAccordionMenu;
	window.toggleHamburgerMenu = new toggleHamburgerMenu;
	window.wrappingModal = new wrappingModal;
});

